import React, { useEffect, useState } from "react";
import { GetServiceCaller,PostServiceCaller } from "../../../../../services/serviceCaller";
import { API_URL } from "../../../../../constants";
import Dynamic_PR_table from "../../../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";
import { Modal, Button } from "react-bootstrap";
import { toast } from 'react-toastify';

const PRReport = () => {
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState({});
  const [apiStatus, setApiStatus] = useState();
  const [searchTerm, setSearchTerm] = useState("");

  /* 🔹 FILTER STATES */
  const [filterFormData, setFilterFormData] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [appraisalCycle, setAppraisalCycle] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    dispatch(updateNavbarHeading("PR Master Report"));
    fetchData(); // initial load
  }, []);

  /* ================= FETCH DATA ================= */
  const fetchData = async () => {
    try {
      const employeeId =
        filterFormData.find(f => f.label === "Employee")?.value || 0;

      const appraisalId =
        filterFormData.find(f => f.label === "Appraisal Cycle")?.value || 0;

      const response = await GetServiceCaller(
        `${API_URL}pr-category-report?EmployeeID=${employeeId}&AppraisalCycle=${appraisalId}`
      );

      setApiStatus(response?.status);

      if (response?.status === 200) {
        const reportData = response?.data?.reportdata || [];
        setData(reportData);

        /* 🔥 DYNAMIC COLUMNS */
        if (reportData.length > 0) {
          const dynamicColumns = {};
          Object.keys(reportData[0]).forEach(key => {
            dynamicColumns[key] = {
              text: key.replace(/_/g, " "),
              align: "left",
              visible: true
            };
          });
          setColumns(dynamicColumns);
        }

        /* 🔹 FILTER OPTIONS */
        setEmployee(
          response?.data?.employee?.map(e => ({
            value: e.value,
            label: e.text
          })) || []
        );

        setAppraisalCycle(
          response?.data?.appraisal?.map(a => ({
            value: a.value,
            label: a.text
          })) || []
        );
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  /* ================= FILTER HANDLERS ================= */
  const handleChange = (e, name) => {
    setFilterFormData(prev => {
      const index = prev.findIndex(i => i.label === name);
      if (index !== -1) {
        const updated = [...prev];
        updated[index].value = e.value;
        return updated;
      }
      return [...prev, { label: name, value: e.value }];
    });
  };

  const handleGetData = () => {
    fetchData();
  };

  const handleReset = () => {
    setFilterFormData([]);
    fetchData();
  };
    
   /* =================== MAIL SEND HANDLER =================== */
  const sendMail = async () => {
    //setShowModal(false);
    setIsSending(true);  // show loader immediately

    try {
      const response = await PostServiceCaller(`${API_URL}pr-remainder-mail`, {});
      if (response?.status === 200) {
          setTimeout(() => {
            toast.success("Reminder mail sent successfully!");
            setIsSending(false);
            setShowModal(false);
          }, 1000);
        } else {
          toast.error(`Failed to send mail!`);
        }
      } catch (error) {
        console.error("Mail API Error:", error);
        toast.error(`Error while sending mail!`);
      }
  };


  /* ================= FILTER CONFIG ================= */
  const formDatas = [
    { name: "Employee", type: "Select", options: employee },
    { name: "Appraisal Cycle", type: "Select", options: appraisalCycle }
  ];

  /* ⛔ WAIT UNTIL COLUMNS READY */
  if (!Object.keys(columns).length) return null;

  return (
    <div className="container-fluid mt-3">
      <div className="position-relative">

        {/* Your button placed over the component */}
        <button
            className="btn btn-primary"
            onClick={() => setShowModal(true)}
             style={{
              position: "absolute",
              right: "110px",
              padding: "6px 12px",   
              fontSize: "12px",      
              borderRadius: "4px",  
              zIndex: 10,
              backgroundColor: "#27568b",
              color: "white",
              border: "none",
              cursor: "pointer"
            }}
        >
            Send Reminder 
        </button>

   
      <Dynamic_PR_table
        data={data}
        columns={columns}
        itemsPerPage={8}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        isSorting={true}
        isApiStatus={apiStatus}

        /* 🔹 FILTER PROPS */
        isFilterRequired={true}
        formDatas={formDatas}
        handleChange={handleChange}
        handleGetData={handleGetData}
        handleReset={handleReset}
        filterFormData={filterFormData}

        /* 🔹 UI FLAGS */
        isAddNewBtnRequired={false}
        isActionRequired={false}
        isColumnChooserRequired={false}
      />
      {/* ================= MODAL ================= */}
      <Modal show={showModal} onHide={() => !isSending && setShowModal(false)}backdrop="static" keyboard={false}centered size="sm">
        <Modal.Header>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to send reminders?
        </Modal.Body>

        <Modal.Footer>
          <Button className="custom-btn" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
           <Button
            className="custom-btn"
            onClick={sendMail}
            disabled={isSending}
           >
              {isSending ? (
                <span className="spinner-border spinner-border-sm"></span>
              ) : (
                "Yes, Send Mail"
              )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    </div>
  );
};

export default PRReport;
